<template>
  <div class="achievement">
    <headBox :hideBack="true">
      <el-tabs v-model="tab" @tab-click="tabClick" v-if="userinfo.level != 3">
        <el-tab-pane label="我的业绩" name="1"></el-tab-pane>
        <el-tab-pane label="团队业绩" name="2" v-if="userinfo.isOpenMechanism == 1 && checkAuth('subMechanSettle')"></el-tab-pane>
        <el-tab-pane label="员工业绩排行" name="3"></el-tab-pane>
      </el-tabs>
    </headBox>
    <div class="panel">
      <oneStatistics v-if="tab == '1'"></oneStatistics>
      <statistics v-if="tab == '2'"></statistics>
      <childRank v-if="tab == '3'"></childRank>
    </div>
  </div>
</template>
<script>
import headBox from "@/components/head2.vue";
import oneStatistics from "./component/oneStatistics";
import statistics from "./component/statistics";
import childRank from "./component/childRank";
import { common } from "@/api/mixins";
//当前实例组件
export default {
  mixins: [common],
  data: () => ({
    tab: "1",
    userinfo: {},
    pageNum: 1,
    pageSize: 10,
    total: 0,
    tableData: [],
    search: {}
  }),
  components: {
    oneStatistics,
    statistics,
    childRank,
    headBox
  },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
  },
  methods: {
    // tab切换
    tabClick() {

    },
  },
};
</script>
<style lang="scss" scoped>
@import './achievement.scss';
</style>
